// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Activité#Activités',
    Activities_Text: '1#{0} activité#{0} activités',
    activities_without_dates: 'Activités sans dates',
    Activity: 'Activité',
    Activity_Billing: 'Facturation',
    Activity_Cost: 'Coût de l\'Activité',
    Activity_CostVariance: 'Variation des coûts',
    Activity_HoursLeft: 'restante(s)',
    Activity_InternalCost: 'Coût Interne',
    Activity_Profit: 'Bénéfice',
    Add_Task: 'Ajouter une Tâche',
    All_Saved_Views: 'Toutes les vues enregistrées',
    Apply_Text: 'Appliquer',
    Baseline_Text: 'Ligne de base',
    Board_CreateTaskInProjectPlaceholder: 'Créer dans le projet',
    Board_ShowMore: 'Afficher plus',
    Browse_Views: 'Parcourir les vues',
    Budget_problem_project: 'Le coût réel dépasse le budget total',
    Budget_problem_task: 'Le coût réel de la main-d\'œuvre dépasse le budget total',
    Budget_Text: 'Budget',
    Budget_warning_project: 'Le coût EAC dépasse le budget total',
    Budget_warning_task: 'Le coût de la main-d\'œuvre EAC dépasse le budget total',
    By_Text: 'par',
    CPI_Problem: 'Le CPI est inférieur au seuil',
    Create: 'Créer',
    CreateNewItem: 'Taper ici pour créer un nouveau projet ou une nouvelle activité',
    CreateProject_Tooltip: 'Créer un nouveau projet',
    CriticalPath_Text: 'Chemin critique',
    CustomField_No: 'Non',
    CustomField_Yes: 'Oui',
    DayPluralFormat: '1#Jour#Jours',
    Default_Text: 'Par défaut',
    Delete_Text: 'Supprimer',
    DeleteEntityConfirmation: '<b>y compris toutes les saisies de temps, les messages et les pièces jointes</b> {0}. L\'action ne peut pas être annulée !',
    DeletePermanently: 'Supprimer définitivement',
    DeleteVerb: '1#sera définitivement supprimé#seront définitivement supprimés',
    DeleteVerbActivity: '1#sera définitivement supprimé#seront définitivement supprimés',
    Dependency_AddMore_Text: 'Ajouter plus de dépendances',
    Dependency_Cancel: 'Annuler',
    Dependency_Choose: 'Sélectionner une activité ou saisir un mot clé... ',
    Dependency_days: 'jours',
    Dependency_DelayWarningExample: 'Exemple : -34, 42',
    Dependency_DelayWarningText: 'Saisir un nombre entre -1 000 et 1 000',
    Dependency_DependencyCycle: 'Nous sommes désolés, la dépendance ne peut pas être créée car l\'activité sélectionnée génère une boucle de dépendance.',
    Dependency_DependencyType_Text: 'Type de dépendance',
    Dependency_DependsOn_Text: 'Dépend de',
    Dependency_FinishToStart_Minus1: 'L\'activité commence le jour avant que {0} se termine',
    Dependency_FinishToStart_Minus1_Pattern: 'L\'activité commence <b>le jour avant que</b> \"{0}\" se termine',
    Dependency_FinishToStart_Minus2: 'L\'activité démarre {1} avant que {0} se termine',
    Dependency_FinishToStart_Minus2_Pattern: 'L\'activité démarre <b>{1} avant que</b> \"{0}\" se termine',
    Dependency_FinishToStart_Plus0: 'L\'activité commence le jour où {0} se termine',
    Dependency_FinishToStart_Plus0_Pattern: 'L\'activité commence <b>le jour où</b> \"{0}\" se termine',
    Dependency_FinishToStart_Plus1: 'L\'activité commence le jour après que {0} se termine',
    Dependency_FinishToStart_Plus1_Pattern: 'L\'activité commence <b>le jour après que</b> \"{0}\" se termine',
    Dependency_FinishToStart_Plus2: 'L\'activité commence {1} après que {0} se termine',
    Dependency_FinishToStart_Plus2_Pattern: 'L\'activité commence <b>{1} après que</b> \"{0}\" se termine',
    Dependency_FinishWhenStarted_Text: 'Activité terminée lorsque \"{0}\" est commencée',
    Dependency_FinishWhenStarted_Title: 'Commencer pour terminer',
    Dependency_Lag_Text: 'Décalage',
    Dependency_ParentChildRelationship: 'Nous sommes désolés, la dépendance ne peut pas être créée car l\'une des activités est un parent et une autre activité est son enfant (sous-activité).',
    Dependency_Reason: 'Raison',
    Dependency_Remove_Text: 'Supprimer',
    Dependency_RemoveSingleDependency_Text: 'Supprimer la dépendance',
    Dependency_Save: 'Enregistrer',
    Dependency_SelectDependsOn_Text: 'Sélectionner dépend de',
    Dependency_StartsWhenFinished_Text: 'L\'activité commence lorsque \"{0}\" est terminée',
    Dependency_StartsWhenFinished_Title: 'Terminer pour commencer',
    Dependency_StartsWhenStarted_Text: 'L\'activité commence lorsque \"{0}\" est commencée',
    Dependency_StartsWhenStarted_Title: 'Commencer pour commencer',
    Dependency_StartToFinish_Minus1: 'L\'activité se termine le jour avant que {0} commence',
    Dependency_StartToFinish_Minus1_Pattern: 'L\'activité se termine <b>le jour avant que</b> \"{0}\" commence',
    Dependency_StartToFinish_Minus2: 'L\'activité se termine {1} avant que {0} démarre',
    Dependency_StartToFinish_Minus2_Pattern: 'L\'activité se termine <b>{1} avant que</b> \"{0}\" démarre',
    Dependency_StartToFinish_Plus0: 'L\'activité se termine le jour où {0} commence',
    Dependency_StartToFinish_Plus0_Pattern: 'L\'activité se termine <b>le jour où</b> \"{0}\" commence',
    Dependency_StartToFinish_Plus1: 'L\'activité se termine le jours après que {0} commence',
    Dependency_StartToFinish_Plus1_Pattern: 'L\'activité se termine <b>le jours après que</b> \"{0}\" commence',
    Dependency_StartToFinish_Plus2: 'L\'activité se termine {1} après que {0} commence',
    Dependency_StartToFinish_Plus2_Pattern: 'L\'activité se termine <b>{1} après que</b> \"{0}\" commence',
    Dependency_StartToStart_Minus1: 'L\'activité commence le jour avant que  {0} commence',
    Dependency_StartToStart_Minus1_Pattern: 'L\'activité commence <b>le jour avant que</b> \"{0}\" commence',
    Dependency_StartToStart_Minus2: 'L\'activité commence {1} avant {0}',
    Dependency_StartToStart_Minus2_Pattern: 'L\'activité commence <b>{1} avant</b> \"{0}\"',
    Dependency_StartToStart_Plus0: 'L\'activité commence le jour où {0} commence',
    Dependency_StartToStart_Plus0_Pattern: 'L\'activité commence <b>le jour où</b> \"{0}\" commence',
    Dependency_StartToStart_Plus1: 'L\'activité commence le jour après que {0} commence',
    Dependency_StartToStart_Plus1_Pattern: 'L\'activité commence <b>le jour après que</b> \"{0}\" commence',
    Dependency_StartToStart_Plus2: 'L\'activité commence {1} après que {0} commence',
    Dependency_StartToStart_Plus2_Pattern: 'L\'activité commence <b>{1} après que</b> \"{0}\" commence',
    Dependency_Warning_Text: 'L\'opération n\'a pas pu être terminée. ',
    Details: 'Détails',
    Edit_Text: 'Modifier',
    empty_sorting_list: 'Saisissez le nom du projet',
    EnterProjectName: 'Saisissez le nom du projet',
    EnterTaskName: 'Saisissez le nom de la tâche',
    EnterViewName_Text: 'Saisir un nom de vue',
    Error_DragAndDrop_BreakingHierarchy: 'Une activité ne peut pas être le parent de sa propre activité parent.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Veuillez changer la vue plane en vue hiérarchique pour modifier la hiérarchie des activités.',
    Error_DragAndDrop_CycleDependencies: 'Cela créera une dépendance cyclique (p. ex. Tâche A dépend de la tâche B, tâche B dépend de la tâche A)',
    Error_DragAndDrop_DifferentProjects: 'Les activités concernées appartiennent à différents projets.',
    Error_DragAndDrop_ReorderWithSorting: 'La réorganisation des activités n\'est disponible qu\'en activant l\'option de tri Aucun.',
    Error_PresetNotFound: 'La vue sélectionnée a été supprimée ou son partage a été désactivé. Pour continuer, actualisez la page.',
    EstimatedHours_problem: 'Les heures réelles dépassent les heures estimées',
    Export_Activities_Text: 'Exporter des activités au format CSV',
    Export_Import_Text: 'Exporter et importer',
    Export_Projects_Text: 'Exporter des projets au format CSV',
    flat_view: 'Vue plane',
    From: 'de',
    group_by_project: 'Regrouper par projet',
    Hide_Text: 'Cacher',
    hide_uncategorized_tasks: 'Masquer les activités qui ne correspondent à aucun calendrier',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Importer depuis CSV',
    Import_MSProject_Text: 'Importer d\'après MS Project',
    Import_Text: 'Importer',
    Indicator_Counter_Tooltip: 'Nombre d\'activités à risque',
    Indicator_Project_Tooltip: 'Le projet nécessite une attention à :',
    Indicator_Task_Tooltip: 'L\'activité nécessite une attention à :',
    Learn_More_Text: 'En savoir plus',
    Loading_Text: 'Chargement en cours...',
    More_Tasks: '{0} de plus',
    MoreActions_AddActivity: 'Ajouter une activité',
    MoreActions_AddNextActivity: 'Ajouter Sous-Activité',
    MoreActions_SetAsMilestone: 'Marquer comme jalon',
    My_Presets: 'Mon',
    My_Text: ' Moi',
    MyPresetName_Text: 'Mon',
    NewProject: 'Nouveau projet',
    NewProjectBasedOn: 'Nouveau projet basé sur {0}',
    NewTask: 'Nouvelle tâche',
    No_Templates_Text: 'Aucun modèle trouvé.',
    NoSavedViews_Text: 'Aucune vue enregistrée.',
    Of: 'de',
    parent_activities: 'Activités parentes',
    preset_delete: 'Supprimer la vue',
    preset_delete_confirmation: 'Supprimer la vue {0} ?',
    preset_rename: 'Renommer la vue',
    preset_save: 'Enregistrer la vue',
    preset_saveAs: 'Enregistrer la vue sous',
    preset_share: 'Partager avec tout le monde dans cet espace',
    preset_unshare_confirmation: 'Annuler le partage de la vue {0} ?',
    Project: 'Projet',
    Project_ActualBudgetProfitability: 'Rentabilité du budget réelle',
    Project_BudgetedCost: 'Coût Budgétisé',
    Project_CostVariance: 'Variation des coûts',
    Project_EstimatedBudgetProfitability: 'Estimation de la rentabilité du budget',
    Project_Expenses: 'Dépenses',
    Project_InternalCost: 'Coût Interne',
    Project_ProjectBilling: 'Coût du Projet',
    Project_ProjectProfit: 'Bénéfice du Projet',
    Project_ProjectProfitability: 'Rentabilité',
    ProjectEndDate_problem: 'Le projet n\'a pas été achevé à la date prévue',
    Projects: '1#Projet#Projets',
    Projects_Text: '1#{0} projet#{0} projets',
    Rename_Text: 'Renommer',
    Restore_Text: 'Restaurer',
    Save_Text: 'Enregistrer',
    SaveAs_Text: 'Enregistrer sous...',
    Share_Text: 'Partager',
    Shared_With_Me: 'Partagé avec moi',
    Show_Text: 'Afficher',
    SortBy_Text: 'Trier par',
    SPI_Problem: 'Le SPI est inférieur au seuil',
    SubActivities: '1#Sous-activité#Sous-activités',
    switchToNewUI: 'Passer à l’UI nouvelle',
    tab_Board: 'Tableau',
    tab_Calendar: 'Calendrier',
    tab_Gantt: 'Gantt',
    tab_Table: 'Tableau',
    TargetProfit_warning: 'Bénéfice cible inférieur au bénéfice attendu',
    TargetProfitPercentage_warning: 'Bénéfice cible (%) inférieur au bénéfice attendu (%)',
    TaskEndDate_problem: 'La tâche n\'a pas été terminée à la date d\'échéance',
    Templates_Popup_Title: 'Basé sur le modèle :',
    TimerText: '1#{0} seconde#{0} secondes',
    Tools_Menu_Text: 'Outils',
    Tooltip_DefaultPresetIcon: 'Sélectionner ou gérer les vues enregistrées',
    Tooltip_RevertToDefaultPreset: 'Revenir à la vue par défaut',
    Tooltip_SaveDefaultPreset: 'Enregistrer comme Vue votre agencement et vos filtres actuels',
    Tooltip_SharedByMePreset: 'Partagé par moi',
    TotalTargetRevenue_warning: 'Montant EAC facturable inférieur au revenu cible total',
    uncategorized_tasks: 'Activités sans calendriers',
    Unshare_Text: 'Départager',
    WBSNumber_Text: 'WBS',
};
